import CircuitTable from 'components/circuit-table';
import CircuitsGroupChart from 'components/charts/circuits-group-chart';


function TagView({device}) {
  return (<>
    <header>
      <h2>
        <span className="device-icon tag"></span>
        {device.model.name}
      </h2>
    </header>
    <section>
      <div className="container-wrapper">
        <CircuitTable device={device} />
      </div>
      <CircuitsGroupChart circuitIds={device.model.children.map(c => c.id)} />
    </section>
  </>);
}

export default TagView;
